import { createFileRoute, redirect } from '@tanstack/react-router';
import { AppShell } from '../../shared/layouts/app-shell';

export const Route = createFileRoute('/_authenticated')({
  beforeLoad: ({ context, location }) => {
    if (!context.auth.getAccess()) {
      throw redirect({
        to: '/login',
        search: { redirect: location.href },
      });
    }
  },
  component: AppShell,
});
